import { FormService } from './../services/form.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiLocauxService } from '../services/api-locaux.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-form-locaux',
  templateUrl: './form-locaux.component.html',
  styleUrls: ['./form-locaux.component.css']
})
export class FormLocauxComponent implements OnInit {
  locauxForm;
  
  typesLocaux;
  superficies;

  territoires : Array<any> = [];
  communes : Array<any> = [];
  zones : Array<any> = [];

  locaux;
  total = 0;

  byZa = 0;

  loading = false;
  base_url;

  initSetted = {
    'territoire' : 0,
    'types' : [],
    'superficies' : []
  };
  
  constructor(private _formService : FormService, private _activatedRoute : ActivatedRoute, private _apiService : ApiLocauxService, private _router : Router) { 
    this.base_url = environment.base_url;
  }

  ngOnInit() {
    this.typesLocaux = this._formService.getTypesLocaux();
    this.superficies = this._formService.getSuperficiesLocaux();

    this._activatedRoute.data
      .subscribe((data: { results: any }) => {
        console.log('hohooh :', data);
        this.territoires = data.results.territoires;
        this.zones = data.results.zones;
        this.communes = data.results.communes;
        this.byZa = data.results.byZa;
      });

    this.initForm();

    this._apiService.getLocauxByFilter(1).then(results => {
      console.log('noresolver form locaux :', results);
      if (results) {
        this.locaux = results.results;
        this.total = results.total.nb;
      }
    });
  }

  initForm() {
    var setted = this._apiService.getLocalFormDatas();
    

    if(this.byZa == 0) {
      if(setted != null) {
        this.initSetted = this._apiService.getLocalFormDatas();
        
        this.locauxForm = new FormGroup({
          'types': new FormArray([]),
          'superficies': new FormArray([]),
          'avendre': new FormControl(setted.avendre, []),
          'alouer': new FormControl(setted.alouer, []),
          'territoire': new FormControl(setted.territoire, []),
          'commune': new FormControl(setted.commune, []),
          'zone': new FormControl(setted.zone, [])
        });

        this.initCheckboxes('superficies', setted.superficies);
        this.initCheckboxes('types', setted.types);

        this.onChangeTerritoire(setted.territoire, true);

      } else {
        this.locauxForm = new FormGroup({
          'types': new FormArray([]),
          'superficies': new FormArray([]),
          'avendre': new FormControl(true, []),
          'alouer': new FormControl(true, []),
          'territoire': new FormControl(0, []),
          'commune': new FormControl('', []),
          'zone': new FormControl('', [])
        });

      }
      
      this._apiService.setLocalFormDatas(this.locauxForm.value);
    } 
    else {
      this.locauxForm = new FormGroup({
        'types': new FormArray([]),
        'superficies': new FormArray([]),
        'avendre': new FormControl(true, []),
        'alouer': new FormControl(true, []),
        'territoire': new FormControl('', []),
        'commune': new FormControl('', []),
        'zone': new FormControl(this.byZa, [])
      });

      this._apiService.setLocalFormDatas({
        'types': [],
        'superficies': [],
        'avendre': true,
        'alouer': true,
        'territoire': '',
        'commune': '',
        'zone': this.byZa,
      });
    }

  }

  onChangeTypes(event) {
    this.onChangeCheckboxes('types', event);
  }

  onChangeSuperficies(event) {
    this.onChangeCheckboxes('superficies', event);
  }

  onChangeTerritoire(newValue, trigger=false) {
    if (trigger == false) {
      this.locauxForm.controls['commune'].setValue('');
    }

      this._apiService.getCommunesByTerritoire(newValue).then(results => {
        if (results) {
          this.communes = results;
        }
      });
    
  }

  onSubmit() {
    this.loading = true;
    console.log('SUBMIT LOCAUX :', this.locauxForm.value);

    this._apiService.setLocalFormDatas(this.locauxForm.value);

    this._apiService.getLocauxByFilter(1).then(results => {
      console.log('noresolver form locaux :', results);
      if (results) {
        this.locaux = results.results;
        this.total = results.total.nb;

        this.loading = false;
      }
    });

    
  
  }


  onChangeCheckboxes(selector: String, event) {
    const formArray: FormArray = this.locauxForm.get(selector) as FormArray;

    /* Selected */
    if(event.target.checked){
      // Add a new control in the arrayForm
      console.log('JORDAN : ', event.target.value); 
      formArray.push(new FormControl(event.target.value));
    }
    /* unselected */
    else{
      // find the unselected element
      let i: number = 0;

      formArray.controls.forEach((ctrl: FormControl) => {
        if(ctrl.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          formArray.removeAt(i);
          return;
        }

        i++;
      });
    }
  }

  initCheckboxes(selector, values) {
    const formArray: FormArray = this.locauxForm.get(selector) as FormArray;

    values.forEach(element => {
      formArray.push(new FormControl(element));
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/locaux/form-locaux/form-locaux.component.ts